import Cookies from 'js-cookie'
import api from '@/store/api'
import { getField, updateField } from 'vuex-map-fields'
import { checkError } from '@/utils/helpers'

const state = {
	loginForm: {
		email: '',
		password: '',
		errors: {
			email: [],
			password: []
		},
		loading: false
	},
	user: null,
	api_token: Cookies.get('token') || null
}

const mutations = {
	updateField
}

const actions = {
	async fetchUser ({ state }) {
		const { data, status } = await api('post', 'authenticate/fetch-user')

		if (status) {
			state.user = data.data
		    Object.freeze(state.user)
			return
		}

		state.user = null
		state.api_token = null
		Cookies.remove('token')
	},

	async login ({ state }, payload) {
		state.loginForm.loading = true

		const { data, status } = await api('post', 'authenticate/login', payload)

		if (status) {
			state.loginForm.loading = false
			Cookies.set('token', data.data.api_token, { expires: 36500 })
			state.user = data.data
			Object.freeze(state.user)
			state.loginForm = {
				email: '',
				password: '',
				errors: {
					email: [],
					password: []
				}
			}
			return true
		}
		state.loginForm.loading = false
		state.loginForm.errors = data.errors
		state.loginForm.password = ''

		return false
	},

	logout ({ state }) {
		Cookies.remove('token')
		state.user = null
		state.apiToken = null
	}
}

const getters = {
	getField,
	emailError: state => {
		return checkError('email', state.loginForm)
	},
	passwordError: state => {
		return checkError('password', state.loginForm)
	},
	credentialError: state => {
		return checkError('0', state.loginForm)
	},
	apiToken: state => state.api_token,
	getLoggedInState: state => state.user !== null
}

export {
	state,
	getters,
	mutations,
	actions
}
